module.exports = __webpack_public_path__ + "static/img/july09 2024.c9460edd.png";